// @ts-nocheck
import * as Types from '../../graphqlClient/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type GetSocietiesQueryVariables = Types.Exact<{
  currentPage: Types.Scalars['Int']['input'];
  pageSize: Types.Scalars['Int']['input'];
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSocietiesQuery = { __typename?: 'Query', societies: { __typename?: 'PagedResultOfSocietyDto', items: Array<{ __typename?: 'SocietyDto', societyId: number, societyCode: string, name: string, breedLogicSocietyId?: number | null, isEbvEnabled: boolean, isPrivate: boolean }> } };

export type GetSocietyByCodeQueryVariables = Types.Exact<{
  societyCode: Types.Scalars['String']['input'];
}>;


export type GetSocietyByCodeQuery = { __typename?: 'Query', societies: { __typename?: 'PagedResultOfSocietyDto', items: Array<{ __typename?: 'SocietyDto', societyId: number, societyCode: string, name: string, breedLogicSocietyId?: number | null, isEbvEnabled: boolean, isPrivate: boolean, currency: string, country: string }> } };

export type GetSocietyAccessByCodeQueryVariables = Types.Exact<{
  societyCode: Types.Scalars['String']['input'];
}>;


export type GetSocietyAccessByCodeQuery = { __typename?: 'Query', societyAccessByCode: { __typename?: 'SocietyAccessByCodeDto', exists: boolean, isPrivate: boolean, canAccess: boolean, societyId: number, societyCode: string, name: string } };

export type GetSocietySettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSocietySettingsQuery = { __typename?: 'Query', societySettings?: Array<{ __typename?: 'SocietySettingDto', societyId?: number | null, value?: string | null, url?: string | null, settingUrl?: string | null, societySettingType: Types.SocietySettingType, onlineRegistrationProvider?: string | null, ilrOnlineRegion?: string | null, tooltip?: string | null }> | null };

export type GetAnimalEbvsQueryVariables = Types.Exact<{
  requestInput: Types.AnimalEbvFilteredRequestInput;
}>;


export type GetAnimalEbvsQuery = { __typename?: 'Query', animalEbvs: { __typename?: 'PagedResultOfAnimalEbvDto', totalCount: number, items: Array<{ __typename?: 'AnimalEbvDto', animalId: number, animalIdent?: string | null, animalName?: string | null, animalStatus?: string | null, animalTattoo?: string | null, breederId?: number | null, breederName?: string | null, breederDetailsAvailFlag?: string | null, calvingYear?: number | null, saleCount: number, hasProof: boolean, currentOwnerId?: number | null, currentOwnerName?: string | null, currentOwnerDetailsAvailFlag?: string | null, damId?: number | null, damIdent?: string | null, damName?: string | null, dateOfBirth?: any | null, registrationStatus?: string | null, sex?: string | null, sireId?: number | null, sireIdent?: string | null, sireName?: string | null, societyId: number, societyCode?: string | null, traitLeader?: string | null, traitsObserved?: string | null, numberOfHerds?: number | null, progenyCount?: number | null, scanProgenyCount?: number | null, carcaseProgenyCount?: number | null, daughtersCount?: number | null, ebvDescription?: string | null, societyAnimalField1?: string | null, societyAnimalField2?: string | null, societyAnimalField3?: string | null, societyAnimalField4?: string | null, societyAnimalField5?: string | null, societyAnimalField6?: string | null, societyAnimalField7?: string | null, societyAnimalField8?: string | null, societyAnimalField9?: string | null, societyAnimalField10?: string | null, societyAnimalField11?: string | null, societyAnimalField12?: string | null, societyAnimalField13?: string | null, societyAnimalField14?: string | null, societyAnimalField15?: string | null, societyAnimalField16?: string | null, societyAnimalField17?: string | null, societyAnimalField18?: string | null, societyAnimalField19?: string | null, societyAnimalField20?: string | null, societyAnimalField21?: string | null, societyAnimalField22?: string | null, societyAnimalField23?: string | null, societyAnimalField24?: string | null, societyAnimalField25?: string | null, societyAnimalField26?: string | null, societyAnimalField27?: string | null, societyAnimalField28?: string | null, societyAnimalField29?: string | null, societyAnimalField30?: string | null, ebv1?: any | null, ebv1Accuracy?: any | null, ebv2?: any | null, ebv2Accuracy?: any | null, ebv3?: any | null, ebv3Accuracy?: any | null, ebv4?: any | null, ebv4Accuracy?: any | null, ebv5?: any | null, ebv5Accuracy?: any | null, ebv6?: any | null, ebv6Accuracy?: any | null, ebv7?: any | null, ebv7Accuracy?: any | null, ebv8?: any | null, ebv8Accuracy?: any | null, ebv9?: any | null, ebv9Accuracy?: any | null, ebv10?: any | null, ebv10Accuracy?: any | null, ebv11?: any | null, ebv11Accuracy?: any | null, ebv12?: any | null, ebv12Accuracy?: any | null, ebv13?: any | null, ebv13Accuracy?: any | null, ebv14?: any | null, ebv14Accuracy?: any | null, ebv15?: any | null, ebv15Accuracy?: any | null, ebv16?: any | null, ebv16Accuracy?: any | null, ebv17?: any | null, ebv17Accuracy?: any | null, ebv18?: any | null, ebv18Accuracy?: any | null, ebv19?: any | null, ebv19Accuracy?: any | null, ebv20?: any | null, ebv20Accuracy?: any | null, ebv21?: any | null, ebv21Accuracy?: any | null, ebv22?: any | null, ebv22Accuracy?: any | null, ebv23?: any | null, ebv23Accuracy?: any | null, ebv24?: any | null, ebv24Accuracy?: any | null, ebv25?: any | null, ebv25Accuracy?: any | null, ebv26?: any | null, ebv26Accuracy?: any | null, ebv1Percentile?: any | null, ebv2Percentile?: any | null, ebv3Percentile?: any | null, ebv4Percentile?: any | null, ebv5Percentile?: any | null, ebv6Percentile?: any | null, ebv7Percentile?: any | null, ebv8Percentile?: any | null, ebv9Percentile?: any | null, ebv10Percentile?: any | null, ebv11Percentile?: any | null, ebv12Percentile?: any | null, ebv13Percentile?: any | null, ebv14Percentile?: any | null, ebv15Percentile?: any | null, ebv16Percentile?: any | null, ebv17Percentile?: any | null, ebv18Percentile?: any | null, ebv19Percentile?: any | null, ebv20Percentile?: any | null, ebv21Percentile?: any | null, ebv22Percentile?: any | null, ebv23Percentile?: any | null, ebv24Percentile?: any | null, ebv25Percentile?: any | null, ebv26Percentile?: any | null, documents: Array<{ __typename?: 'DocumentDto', documentGuid: any, url?: string | null, isPrimary: boolean, isDeleted: boolean, fileName?: string | null, documentId: number }> }> } };

export type GetAnimalPedigreeQueryVariables = Types.Exact<{
  animalId: Types.Scalars['Int']['input'];
  maxGen: Types.Scalars['Int']['input'];
}>;


export type GetAnimalPedigreeQuery = { __typename?: 'Query', pedigree: { __typename?: 'PedigreeResponseDto', maxGen: number, root?: { __typename?: 'PedigreeRootDto', animalId: number, ident?: string | null, name?: string | null, sex?: string | null, dob?: string | null, ownerName?: string | null, ownerIdent?: string | null, status?: string | null, tattoo?: string | null } | null, nodes: Array<{ __typename?: 'PedigreeNodeDto', animalId: number, ident?: string | null, name?: string | null, sex?: string | null, dob?: string | null, ownerName?: string | null, ownerIdent?: string | null, status?: string | null, tattoo?: string | null, gen: number, line?: string | null, parentId?: number | null, parentSide?: string | null, sireId?: number | null, damId?: number | null, path?: string | null }> } };

export type GetAnimalExtrasQueryVariables = Types.Exact<{
  animalId: Types.Scalars['Int']['input'];
  extraTypes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type GetAnimalExtrasQuery = { __typename?: 'Query', animalExtras: Array<{ __typename?: 'AnimalExtraDto', societyId: number, animalId: number, extraType: string, societyCode?: string | null, notes?: string | null, updatedAt?: string | null }> };

export type GetLotAnimalEbvsQueryVariables = Types.Exact<{
  requestInput: Types.LotAnimalEbvFilteredRequestInput;
}>;


export type GetLotAnimalEbvsQuery = { __typename?: 'Query', lotAnimalEbvs: { __typename?: 'PagedResultOfLotAnimalEbvDto', totalCount: number, items: Array<{ __typename?: 'LotAnimalEbvDto', saleId: number, lotNo: string, lotNotes?: string | null, lotAnimalName?: string | null, societyLotField1?: number | null, societyLotField2?: number | null, societyLotField3?: number | null, societyLotField4?: string | null, societyLotField5?: string | null, societyLotField6?: string | null, societyLotField7?: string | null, societyLotField8?: string | null, societyLotField9?: string | null, societyLotField10?: string | null, vendorsId: number, vendorsName?: string | null, askingPrice?: number | null, askingPriceDesc?: string | null, salePrice?: number | null, salePriceDesc?: string | null, categoryCode?: string | null, agent?: string | null, lotCount?: number | null, semenFlag?: string | null, lotAnimalId?: number | null, societyId: number, societyCode: string, breederId?: number | null, breederIdent?: string | null, breederName?: string | null, breederDetailsAvailFlag?: string | null, calvingYear?: string | null, currentOwnerId?: number | null, currentOwnerIdent?: string | null, currentOwnerName?: string | null, currentOwnerDetailsAvailFlag?: string | null, damId?: number | null, damIdent?: string | null, damName?: string | null, dateOfBirth?: any | null, registrationStatus?: string | null, sex?: string | null, sireId?: number | null, sireIdent?: string | null, sireName?: string | null, animalId: number, animalIdent?: string | null, animalName?: string | null, animalStatus?: string | null, animalTattoo?: string | null, traitLeader?: string | null, traitsObserved?: string | null, societyAnimalField1?: string | null, societyAnimalField2?: string | null, societyAnimalField3?: string | null, societyAnimalField4?: string | null, societyAnimalField5?: string | null, societyAnimalField6?: string | null, societyAnimalField7?: string | null, societyAnimalField8?: string | null, societyAnimalField9?: string | null, societyAnimalField10?: string | null, societyAnimalField11?: string | null, societyAnimalField12?: string | null, societyAnimalField13?: string | null, societyAnimalField14?: string | null, societyAnimalField15?: string | null, societyAnimalField16?: string | null, societyAnimalField17?: string | null, societyAnimalField18?: string | null, societyAnimalField19?: string | null, societyAnimalField20?: string | null, societyAnimalField21?: string | null, societyAnimalField22?: string | null, societyAnimalField23?: string | null, societyAnimalField24?: string | null, societyAnimalField25?: string | null, societyAnimalField26?: string | null, societyAnimalField27?: string | null, societyAnimalField28?: string | null, societyAnimalField29?: string | null, societyAnimalField30?: string | null, ebv1?: any | null, ebv1Accuracy?: any | null, ebv2?: any | null, ebv2Accuracy?: any | null, ebv3?: any | null, ebv3Accuracy?: any | null, ebv4?: any | null, ebv4Accuracy?: any | null, ebv5?: any | null, ebv5Accuracy?: any | null, ebv6?: any | null, ebv6Accuracy?: any | null, ebv7?: any | null, ebv7Accuracy?: any | null, ebv8?: any | null, ebv8Accuracy?: any | null, ebv9?: any | null, ebv9Accuracy?: any | null, ebv10?: any | null, ebv10Accuracy?: any | null, ebv11?: any | null, ebv11Accuracy?: any | null, ebv12?: any | null, ebv12Accuracy?: any | null, ebv13?: any | null, ebv13Accuracy?: any | null, ebv14?: any | null, ebv14Accuracy?: any | null, ebv15?: any | null, ebv15Accuracy?: any | null, ebv16?: any | null, ebv16Accuracy?: any | null, ebv17?: any | null, ebv17Accuracy?: any | null, ebv18?: any | null, ebv18Accuracy?: any | null, ebv19?: any | null, ebv19Accuracy?: any | null, ebv20?: any | null, ebv20Accuracy?: any | null, ebv21?: any | null, ebv21Accuracy?: any | null, ebv22?: any | null, ebv22Accuracy?: any | null, ebv23?: any | null, ebv23Accuracy?: any | null, ebv24?: any | null, ebv24Accuracy?: any | null, ebv25?: any | null, ebv25Accuracy?: any | null, ebv26?: any | null, ebv26Accuracy?: any | null, ebv1Percentile?: any | null, ebv2Percentile?: any | null, ebv3Percentile?: any | null, ebv4Percentile?: any | null, ebv5Percentile?: any | null, ebv6Percentile?: any | null, ebv7Percentile?: any | null, ebv8Percentile?: any | null, ebv9Percentile?: any | null, ebv10Percentile?: any | null, ebv11Percentile?: any | null, ebv12Percentile?: any | null, ebv13Percentile?: any | null, ebv14Percentile?: any | null, ebv15Percentile?: any | null, ebv16Percentile?: any | null, ebv17Percentile?: any | null, ebv18Percentile?: any | null, ebv19Percentile?: any | null, ebv20Percentile?: any | null, ebv21Percentile?: any | null, ebv22Percentile?: any | null, ebv23Percentile?: any | null, ebv24Percentile?: any | null, ebv25Percentile?: any | null, ebv26Percentile?: any | null, sireAnimalId: number, sireAnimalIdent?: string | null, sireAnimalName?: string | null, sireEBV1?: any | null, sireEBV1Accuracy?: any | null, sireEBV2?: any | null, sireEBV2Accuracy?: any | null, sireEBV3?: any | null, sireEBV3Accuracy?: any | null, sireEBV4?: any | null, sireEBV4Accuracy?: any | null, sireEBV5?: any | null, sireEBV5Accuracy?: any | null, sireEBV6?: any | null, sireEBV6Accuracy?: any | null, sireEBV7?: any | null, sireEBV7Accuracy?: any | null, sireEBV8?: any | null, sireEBV8Accuracy?: any | null, sireEBV9?: any | null, sireEBV9Accuracy?: any | null, sireEBV10?: any | null, sireEBV10Accuracy?: any | null, sireEBV11?: any | null, sireEBV11Accuracy?: any | null, sireEBV12?: any | null, sireEBV12Accuracy?: any | null, sireEBV13?: any | null, sireEBV13Accuracy?: any | null, sireEBV14?: any | null, sireEBV14Accuracy?: any | null, sireEBV15?: any | null, sireEBV15Accuracy?: any | null, sireEBV16?: any | null, sireEBV16Accuracy?: any | null, sireEBV17?: any | null, sireEBV17Accuracy?: any | null, sireEBV18?: any | null, sireEBV18Accuracy?: any | null, sireEBV19?: any | null, sireEBV19Accuracy?: any | null, sireEBV20?: any | null, sireEBV20Accuracy?: any | null, sireEBV21?: any | null, sireEBV21Accuracy?: any | null, sireEBV22?: any | null, sireEBV22Accuracy?: any | null, sireEBV23?: any | null, sireEBV23Accuracy?: any | null, sireEBV24?: any | null, sireEBV24Accuracy?: any | null, sireEBV25?: any | null, sireEBV25Accuracy?: any | null, sireEBV26?: any | null, sireEBV26Accuracy?: any | null, damAnimalId: number, damAnimalIdent?: string | null, damAnimalName?: string | null, damEBV1?: any | null, damEBV1Accuracy?: any | null, damEBV2?: any | null, damEBV2Accuracy?: any | null, damEBV3?: any | null, damEBV3Accuracy?: any | null, damEBV4?: any | null, damEBV4Accuracy?: any | null, damEBV5?: any | null, damEBV5Accuracy?: any | null, damEBV6?: any | null, damEBV6Accuracy?: any | null, damEBV7?: any | null, damEBV7Accuracy?: any | null, damEBV8?: any | null, damEBV8Accuracy?: any | null, damEBV9?: any | null, damEBV9Accuracy?: any | null, damEBV10?: any | null, damEBV10Accuracy?: any | null, damEBV11?: any | null, damEBV11Accuracy?: any | null, damEBV12?: any | null, damEBV12Accuracy?: any | null, damEBV13?: any | null, damEBV13Accuracy?: any | null, damEBV14?: any | null, damEBV14Accuracy?: any | null, damEBV15?: any | null, damEBV15Accuracy?: any | null, damEBV16?: any | null, damEBV16Accuracy?: any | null, damEBV17?: any | null, damEBV17Accuracy?: any | null, damEBV18?: any | null, damEBV18Accuracy?: any | null, damEBV19?: any | null, damEBV19Accuracy?: any | null, damEBV20?: any | null, damEBV20Accuracy?: any | null, damEBV21?: any | null, damEBV21Accuracy?: any | null, damEBV22?: any | null, damEBV22Accuracy?: any | null, damEBV23?: any | null, damEBV23Accuracy?: any | null, damEBV24?: any | null, damEBV24Accuracy?: any | null, damEBV25?: any | null, damEBV25Accuracy?: any | null, damEBV26?: any | null, damEBV26Accuracy?: any | null, sale?: { __typename?: 'SaleDto', saleId: number, saleName?: string | null, saleType?: string | null, saleDate?: any | null, publishTillDate?: any | null } | null, documents: Array<{ __typename?: 'DocumentDto', documentGuid: any, url?: string | null, isPrimary: boolean, isDeleted: boolean, fileName?: string | null, documentId: number }>, animalDocuments: Array<{ __typename?: 'DocumentDto', documentGuid: any, fileName?: string | null, url?: string | null, isPrimary: boolean, isDeleted: boolean, documentId: number }> }> } };

export type GetAnimalMediaLotDocumentsQueryVariables = Types.Exact<{
  requestInput: Types.LotAnimalEbvFilteredRequestInput;
}>;


export type GetAnimalMediaLotDocumentsQuery = { __typename?: 'Query', lotAnimalEbvs: { __typename?: 'PagedResultOfLotAnimalEbvDto', totalCount: number, items: Array<{ __typename?: 'LotAnimalEbvDto', saleId: number, lotNo: string, lotAnimalId?: number | null, animalId: number, sale?: { __typename?: 'SaleDto', saleId: number, saleName?: string | null, saleDate?: any | null } | null, documents: Array<{ __typename?: 'DocumentDto', documentGuid: any, documentId: number, fileName?: string | null, url?: string | null, isPrimary: boolean, isDeleted: boolean, sequenceNumber?: number | null }>, animalDocuments: Array<{ __typename?: 'DocumentDto', documentGuid: any, documentId: number, fileName?: string | null, url?: string | null, isPrimary: boolean, isDeleted: boolean, sequenceNumber?: number | null }> }> } };

export type GetSalesQueryVariables = Types.Exact<{
  requestInput: Types.SaleFilteredRequestInput;
}>;


export type GetSalesQuery = { __typename?: 'Query', sales: { __typename?: 'PagedResultOfSaleDto', totalCount: number, items: Array<{ __typename?: 'SaleDto', lotCount?: number | null, saleDate?: any | null, saleId: number, saleName?: string | null, saleNotes?: string | null, saleLocation?: string | null, saleType?: string | null, saleDateDescription?: string | null, extraInfoUrl1?: string | null, societySaleField1?: number | null, agent1?: { __typename?: 'AgentDto', agentId: string, agentName?: string | null, agentUrl?: string | null, agentLogoFileName: string, imageUrl?: string | null } | null, agent2?: { __typename?: 'AgentDto', agentId: string, agentName?: string | null, agentUrl?: string | null, agentLogoFileName: string, imageUrl?: string | null } | null }> } };

export type GetMembersQueryVariables = Types.Exact<{
  requestInput: Types.MemberFilteredRequestInput;
}>;


export type GetMembersQuery = { __typename?: 'Query', members: { __typename?: 'PagedResultOfMemberDto', firstItemNumber: number, hasNextPage: boolean, hasPreviousPage: boolean, lastItemNumber: number, pageNumber: number, pageSize: number, totalCount: number, totalPages: number, items: Array<{ __typename?: 'MemberDto', address1?: string | null, address2?: string | null, address3?: string | null, breedplanFlag?: string | null, detailsAvailFlag?: string | null, email?: string | null, herdSize?: number | null, herdSizeDesc?: string | null, homepage?: string | null, itemKey?: number | null, mapDetails?: string | null, memberAuth?: string | null, memberId: number, memberIdent: string, memberNotes?: string | null, memberType?: string | null, memberName?: string | null, memberStatus?: string | null, phoneDetails?: string | null, postcode?: string | null, prefix?: string | null, renewalDate?: string | null, renewalFee?: any | null, societyCode: string, societyId: number, societyMemberField1?: string | null, societyMemberField10?: string | null, societyMemberField11?: string | null, societyMemberField12?: string | null, societyMemberField13?: string | null, societyMemberField14?: string | null, societyMemberField15?: string | null, societyMemberField2?: string | null, societyMemberField3?: string | null, societyMemberField4?: string | null, societyMemberField5?: number | null, societyMemberField6?: string | null, societyMemberField7?: string | null, societyMemberField8?: string | null, societyMemberField9?: string | null, sortname?: string | null, documents: Array<{ __typename?: 'DocumentDto', fileName?: string | null, url?: string | null }> }> } };

export type GetSocietyEbvLogoQueryVariables = Types.Exact<{
  societyId: Types.Scalars['String']['input'];
}>;


export type GetSocietyEbvLogoQuery = { __typename?: 'Query', societies: { __typename?: 'PagedResultOfSocietyDto', items: Array<{ __typename?: 'SocietyDto', settings?: Array<{ __typename?: 'SocietySettingDto', url?: string | null, settingUrl?: string | null, toolTip?: string | null }> | null }> } };

export type CalculateMatingPredictionQueryVariables = Types.Exact<{
  requestInput: Types.MatingPredictorRequestInput;
}>;


export type CalculateMatingPredictionQuery = { __typename?: 'Query', calculateMatingPrediction: { __typename?: 'MatingPredictorResponseDto', calculatedAt: string, warnings: Array<string>, selectionCriteria: { __typename?: 'MatingSelectionCriteriaDto', sireIdents: Array<string>, damIdents: Array<string>, damCalvingYears?: string | null, displayBy: string }, sires: Array<{ __typename?: 'AnimalEbvDto', animalId: number, animalIdent?: string | null, animalName?: string | null, sex?: string | null, dateOfBirth?: any | null, sireId?: number | null, sireIdent?: string | null, sireName?: string | null, damId?: number | null, damIdent?: string | null, damName?: string | null, ebv1?: any | null, ebv1Accuracy?: any | null, ebv2?: any | null, ebv2Accuracy?: any | null, ebv3?: any | null, ebv3Accuracy?: any | null, ebv4?: any | null, ebv4Accuracy?: any | null, ebv5?: any | null, ebv5Accuracy?: any | null, ebv6?: any | null, ebv6Accuracy?: any | null, ebv7?: any | null, ebv7Accuracy?: any | null, ebv8?: any | null, ebv8Accuracy?: any | null, ebv9?: any | null, ebv9Accuracy?: any | null, ebv10?: any | null, ebv10Accuracy?: any | null, ebv11?: any | null, ebv11Accuracy?: any | null, ebv12?: any | null, ebv12Accuracy?: any | null, ebv13?: any | null, ebv13Accuracy?: any | null, ebv14?: any | null, ebv14Accuracy?: any | null, ebv15?: any | null, ebv15Accuracy?: any | null, ebv16?: any | null, ebv16Accuracy?: any | null, ebv17?: any | null, ebv17Accuracy?: any | null, ebv18?: any | null, ebv18Accuracy?: any | null, ebv19?: any | null, ebv19Accuracy?: any | null, ebv20?: any | null, ebv20Accuracy?: any | null, ebv21?: any | null, ebv21Accuracy?: any | null, ebv22?: any | null, ebv22Accuracy?: any | null, ebv23?: any | null, ebv23Accuracy?: any | null, ebv24?: any | null, ebv24Accuracy?: any | null, ebv25?: any | null, ebv25Accuracy?: any | null, ebv26?: any | null, ebv26Accuracy?: any | null }>, dams: Array<{ __typename?: 'AnimalEbvDto', animalId: number, animalIdent?: string | null, animalName?: string | null, sex?: string | null, dateOfBirth?: any | null, sireId?: number | null, sireIdent?: string | null, sireName?: string | null, damId?: number | null, damIdent?: string | null, damName?: string | null, ebv1?: any | null, ebv1Accuracy?: any | null, ebv2?: any | null, ebv2Accuracy?: any | null, ebv3?: any | null, ebv3Accuracy?: any | null, ebv4?: any | null, ebv4Accuracy?: any | null, ebv5?: any | null, ebv5Accuracy?: any | null, ebv6?: any | null, ebv6Accuracy?: any | null, ebv7?: any | null, ebv7Accuracy?: any | null, ebv8?: any | null, ebv8Accuracy?: any | null, ebv9?: any | null, ebv9Accuracy?: any | null, ebv10?: any | null, ebv10Accuracy?: any | null, ebv11?: any | null, ebv11Accuracy?: any | null, ebv12?: any | null, ebv12Accuracy?: any | null, ebv13?: any | null, ebv13Accuracy?: any | null, ebv14?: any | null, ebv14Accuracy?: any | null, ebv15?: any | null, ebv15Accuracy?: any | null, ebv16?: any | null, ebv16Accuracy?: any | null, ebv17?: any | null, ebv17Accuracy?: any | null, ebv18?: any | null, ebv18Accuracy?: any | null, ebv19?: any | null, ebv19Accuracy?: any | null, ebv20?: any | null, ebv20Accuracy?: any | null, ebv21?: any | null, ebv21Accuracy?: any | null, ebv22?: any | null, ebv22Accuracy?: any | null, ebv23?: any | null, ebv23Accuracy?: any | null, ebv24?: any | null, ebv24Accuracy?: any | null, ebv25?: any | null, ebv25Accuracy?: any | null, ebv26?: any | null, ebv26Accuracy?: any | null }>, results: Array<{ __typename?: 'MatingPairResultDto', sireId: number, damId: number, projectedEbvs: Array<{ __typename?: 'ProjectedEbvDto', ebvNumber: number, value?: any | null, accuracy?: string | null, accuracyValue?: number | null, percentile?: number | null }>, inbreeding?: { __typename?: 'InbreedingResultDto', coefficient: number, coefficientPercent: string, minimumGenerations: number, averageRelatedness: number } | null }>, breedAverages: Array<{ __typename?: 'BreedAverageEbvDto', ebvNumber: number, value?: any | null, label?: string | null }> } };

export type GetAnimalEbvCountQueryVariables = Types.Exact<{
  requestInput: Types.AnimalEbvFilteredRequestInput;
}>;


export type GetAnimalEbvCountQuery = { __typename?: 'Query', animalEbvs: { __typename?: 'PagedResultOfAnimalEbvDto', totalCount: number } };

export type GetLotAnimalEbvCountQueryVariables = Types.Exact<{
  requestInput: Types.LotAnimalEbvFilteredRequestInput;
}>;


export type GetLotAnimalEbvCountQuery = { __typename?: 'Query', lotAnimalEbvs: { __typename?: 'PagedResultOfLotAnimalEbvDto', totalCount: number } };

export type GetMembersCountQueryVariables = Types.Exact<{
  requestInput: Types.MemberFilteredRequestInput;
}>;


export type GetMembersCountQuery = { __typename?: 'Query', members: { __typename?: 'PagedResultOfMemberDto', totalCount: number } };

export type QuickSearchAnimalEbvsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
  top: Types.Scalars['Int']['input'];
  sex?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type QuickSearchAnimalEbvsQuery = { __typename?: 'Query', quickSearchAnimalEbvs: Array<{ __typename?: 'AnimalQuickSearchDto', animalId: number, animalIdent?: string | null, animalName?: string | null, sex?: string | null, isEbvData: boolean }> };

export type QuickSearchMembersQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
  societyId: Types.Scalars['Int']['input'];
  top: Types.Scalars['Int']['input'];
}>;


export type QuickSearchMembersQuery = { __typename?: 'Query', quickSearchMembers: Array<{ __typename?: 'MemberQuickSearchDto', memberId: number, memberIdent: string, memberName?: string | null }> };


export const GetSocietiesDocument = gql`
    query GetSocieties($currentPage: Int!, $pageSize: Int!, $searchTerm: String) {
  societies(
    requestInput: {pagination: {currentPage: $currentPage, pageSize: $pageSize}, sortOptions: {direction: ASCENDING, field: NAME}, searchTerm: $searchTerm}
  ) {
    items {
      societyId
      societyCode
      name
      breedLogicSocietyId
      isEbvEnabled
      isPrivate
    }
  }
}
    `;

/**
 * __useGetSocietiesQuery__
 *
 * To run a query within a React component, call `useGetSocietiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocietiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocietiesQuery({
 *   variables: {
 *      currentPage: // value for 'currentPage'
 *      pageSize: // value for 'pageSize'
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetSocietiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSocietiesQuery, GetSocietiesQueryVariables> & ({ variables: GetSocietiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSocietiesQuery, GetSocietiesQueryVariables>(GetSocietiesDocument, options);
      }
export function useGetSocietiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSocietiesQuery, GetSocietiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSocietiesQuery, GetSocietiesQueryVariables>(GetSocietiesDocument, options);
        }
// @ts-ignore
export function useGetSocietiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSocietiesQuery, GetSocietiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietiesQuery, GetSocietiesQueryVariables>;
export function useGetSocietiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietiesQuery, GetSocietiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietiesQuery | undefined, GetSocietiesQueryVariables>;
export function useGetSocietiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietiesQuery, GetSocietiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSocietiesQuery, GetSocietiesQueryVariables>(GetSocietiesDocument, options);
        }
export type GetSocietiesQueryHookResult = ReturnType<typeof useGetSocietiesQuery>;
export type GetSocietiesLazyQueryHookResult = ReturnType<typeof useGetSocietiesLazyQuery>;
export type GetSocietiesSuspenseQueryHookResult = ReturnType<typeof useGetSocietiesSuspenseQuery>;
export type GetSocietiesQueryResult = ApolloReactCommon.QueryResult<GetSocietiesQuery, GetSocietiesQueryVariables>;
export const GetSocietyByCodeDocument = gql`
    query GetSocietyByCode($societyCode: String!) {
  societies(
    requestInput: {pagination: {currentPage: 1, pageSize: 1}, filterOptions: {field: SOCIETY_CODE, operator: EQUALS, value: $societyCode}}
  ) {
    items {
      societyId
      societyCode
      name
      breedLogicSocietyId
      isEbvEnabled
      isPrivate
      currency
      country
    }
  }
}
    `;

/**
 * __useGetSocietyByCodeQuery__
 *
 * To run a query within a React component, call `useGetSocietyByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocietyByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocietyByCodeQuery({
 *   variables: {
 *      societyCode: // value for 'societyCode'
 *   },
 * });
 */
export function useGetSocietyByCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables> & ({ variables: GetSocietyByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>(GetSocietyByCodeDocument, options);
      }
export function useGetSocietyByCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>(GetSocietyByCodeDocument, options);
        }
// @ts-ignore
export function useGetSocietyByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>;
export function useGetSocietyByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyByCodeQuery | undefined, GetSocietyByCodeQueryVariables>;
export function useGetSocietyByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>(GetSocietyByCodeDocument, options);
        }
export type GetSocietyByCodeQueryHookResult = ReturnType<typeof useGetSocietyByCodeQuery>;
export type GetSocietyByCodeLazyQueryHookResult = ReturnType<typeof useGetSocietyByCodeLazyQuery>;
export type GetSocietyByCodeSuspenseQueryHookResult = ReturnType<typeof useGetSocietyByCodeSuspenseQuery>;
export type GetSocietyByCodeQueryResult = ApolloReactCommon.QueryResult<GetSocietyByCodeQuery, GetSocietyByCodeQueryVariables>;
export const GetSocietyAccessByCodeDocument = gql`
    query GetSocietyAccessByCode($societyCode: String!) {
  societyAccessByCode(societyCode: $societyCode) {
    exists
    isPrivate
    canAccess
    societyId
    societyCode
    name
  }
}
    `;

/**
 * __useGetSocietyAccessByCodeQuery__
 *
 * To run a query within a React component, call `useGetSocietyAccessByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocietyAccessByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocietyAccessByCodeQuery({
 *   variables: {
 *      societyCode: // value for 'societyCode'
 *   },
 * });
 */
export function useGetSocietyAccessByCodeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables> & ({ variables: GetSocietyAccessByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>(GetSocietyAccessByCodeDocument, options);
      }
export function useGetSocietyAccessByCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>(GetSocietyAccessByCodeDocument, options);
        }
// @ts-ignore
export function useGetSocietyAccessByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>;
export function useGetSocietyAccessByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyAccessByCodeQuery | undefined, GetSocietyAccessByCodeQueryVariables>;
export function useGetSocietyAccessByCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>(GetSocietyAccessByCodeDocument, options);
        }
export type GetSocietyAccessByCodeQueryHookResult = ReturnType<typeof useGetSocietyAccessByCodeQuery>;
export type GetSocietyAccessByCodeLazyQueryHookResult = ReturnType<typeof useGetSocietyAccessByCodeLazyQuery>;
export type GetSocietyAccessByCodeSuspenseQueryHookResult = ReturnType<typeof useGetSocietyAccessByCodeSuspenseQuery>;
export type GetSocietyAccessByCodeQueryResult = ApolloReactCommon.QueryResult<GetSocietyAccessByCodeQuery, GetSocietyAccessByCodeQueryVariables>;
export const GetSocietySettingsDocument = gql`
    query GetSocietySettings {
  societySettings(
    pageNumber: 1
    pageSize: 150
    societySettingTypes: [ANIMAL_TAB, MEMBERS_TAB, EBV_TAB, SALES_TAB, MATING_TAB, SEMEN_CATALOG_TAB, DOWNLOADS_TAB, ONLINE_REGISTRATIONS_TAB, SOCIETY_LOGO, EBV_FIELDS, EBV_AVERAGE, EBV_DESCRIPTION, EBV_DESCRIPTION_URL, EBV_DISPLAY_OPTIONS, EBV_PERCENTAGES, EBV_PERCENTAGES_BR, DISPLAY_OPTIONS, ANIMAL_LIST_FIELDS, ANIMAL_DETAIL_FIELDS, LOT_DETAIL_FIELDS, ANIMAL_SEARCH_FIELDS, ANIMAL_SEARCH_FIELDS_EXCLUDE, ANIMAL_QUICK_SEARCH_DEFAULT_OPERATOR, MEMBER_LIST_FIELDS, MEMBER_DETAIL_FIELDS, MEMBER_SEARCH_FIELDS]
  ) {
    societyId
    value
    url
    settingUrl
    tooltip: toolTip
    societySettingType
    onlineRegistrationProvider
    ilrOnlineRegion
  }
}
    `;

/**
 * __useGetSocietySettingsQuery__
 *
 * To run a query within a React component, call `useGetSocietySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocietySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocietySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSocietySettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>(GetSocietySettingsDocument, options);
      }
export function useGetSocietySettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>(GetSocietySettingsDocument, options);
        }
// @ts-ignore
export function useGetSocietySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>;
export function useGetSocietySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietySettingsQuery | undefined, GetSocietySettingsQueryVariables>;
export function useGetSocietySettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>(GetSocietySettingsDocument, options);
        }
export type GetSocietySettingsQueryHookResult = ReturnType<typeof useGetSocietySettingsQuery>;
export type GetSocietySettingsLazyQueryHookResult = ReturnType<typeof useGetSocietySettingsLazyQuery>;
export type GetSocietySettingsSuspenseQueryHookResult = ReturnType<typeof useGetSocietySettingsSuspenseQuery>;
export type GetSocietySettingsQueryResult = ApolloReactCommon.QueryResult<GetSocietySettingsQuery, GetSocietySettingsQueryVariables>;
export const GetAnimalEbvsDocument = gql`
    query GetAnimalEbvs($requestInput: AnimalEbvFilteredRequestInput!) {
  animalEbvs(requestInput: $requestInput) {
    items {
      animalId
      animalIdent
      animalName
      animalStatus
      animalTattoo
      documents {
        documentGuid
        url
        isPrimary
        isDeleted
        fileName
        documentId
      }
      breederId
      breederName
      breederDetailsAvailFlag
      calvingYear
      saleCount
      hasProof
      currentOwnerId
      currentOwnerName
      currentOwnerDetailsAvailFlag
      damId
      damIdent
      damName
      dateOfBirth
      registrationStatus
      sex
      sireId
      sireIdent
      sireName
      societyId
      societyCode
      traitLeader
      traitsObserved
      numberOfHerds
      progenyCount
      scanProgenyCount
      carcaseProgenyCount
      daughtersCount
      ebvDescription
      societyAnimalField1
      societyAnimalField2
      societyAnimalField3
      societyAnimalField4
      societyAnimalField5
      societyAnimalField6
      societyAnimalField7
      societyAnimalField8
      societyAnimalField9
      societyAnimalField10
      societyAnimalField11
      societyAnimalField12
      societyAnimalField13
      societyAnimalField14
      societyAnimalField15
      societyAnimalField16
      societyAnimalField17
      societyAnimalField18
      societyAnimalField19
      societyAnimalField20
      societyAnimalField21
      societyAnimalField22
      societyAnimalField23
      societyAnimalField24
      societyAnimalField25
      societyAnimalField26
      societyAnimalField27
      societyAnimalField28
      societyAnimalField29
      societyAnimalField30
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
      ebv1Percentile
      ebv2Percentile
      ebv3Percentile
      ebv4Percentile
      ebv5Percentile
      ebv6Percentile
      ebv7Percentile
      ebv8Percentile
      ebv9Percentile
      ebv10Percentile
      ebv11Percentile
      ebv12Percentile
      ebv13Percentile
      ebv14Percentile
      ebv15Percentile
      ebv16Percentile
      ebv17Percentile
      ebv18Percentile
      ebv19Percentile
      ebv20Percentile
      ebv21Percentile
      ebv22Percentile
      ebv23Percentile
      ebv24Percentile
      ebv25Percentile
      ebv26Percentile
    }
    totalCount
  }
}
    `;

/**
 * __useGetAnimalEbvsQuery__
 *
 * To run a query within a React component, call `useGetAnimalEbvsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalEbvsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalEbvsQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetAnimalEbvsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables> & ({ variables: GetAnimalEbvsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>(GetAnimalEbvsDocument, options);
      }
export function useGetAnimalEbvsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>(GetAnimalEbvsDocument, options);
        }
// @ts-ignore
export function useGetAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>;
export function useGetAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalEbvsQuery | undefined, GetAnimalEbvsQueryVariables>;
export function useGetAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>(GetAnimalEbvsDocument, options);
        }
export type GetAnimalEbvsQueryHookResult = ReturnType<typeof useGetAnimalEbvsQuery>;
export type GetAnimalEbvsLazyQueryHookResult = ReturnType<typeof useGetAnimalEbvsLazyQuery>;
export type GetAnimalEbvsSuspenseQueryHookResult = ReturnType<typeof useGetAnimalEbvsSuspenseQuery>;
export type GetAnimalEbvsQueryResult = ApolloReactCommon.QueryResult<GetAnimalEbvsQuery, GetAnimalEbvsQueryVariables>;
export const GetAnimalPedigreeDocument = gql`
    query GetAnimalPedigree($animalId: Int!, $maxGen: Int!) {
  pedigree(animalId: $animalId, maxGen: $maxGen) {
    maxGen
    root {
      animalId
      ident
      name
      sex
      dob
      ownerName
      ownerIdent
      status
      tattoo
    }
    nodes {
      animalId
      ident
      name
      sex
      dob
      ownerName
      ownerIdent
      status
      tattoo
      gen
      line
      parentId
      parentSide
      sireId
      damId
      path
    }
  }
}
    `;

/**
 * __useGetAnimalPedigreeQuery__
 *
 * To run a query within a React component, call `useGetAnimalPedigreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalPedigreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalPedigreeQuery({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      maxGen: // value for 'maxGen'
 *   },
 * });
 */
export function useGetAnimalPedigreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables> & ({ variables: GetAnimalPedigreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>(GetAnimalPedigreeDocument, options);
      }
export function useGetAnimalPedigreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>(GetAnimalPedigreeDocument, options);
        }
// @ts-ignore
export function useGetAnimalPedigreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>;
export function useGetAnimalPedigreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalPedigreeQuery | undefined, GetAnimalPedigreeQueryVariables>;
export function useGetAnimalPedigreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>(GetAnimalPedigreeDocument, options);
        }
export type GetAnimalPedigreeQueryHookResult = ReturnType<typeof useGetAnimalPedigreeQuery>;
export type GetAnimalPedigreeLazyQueryHookResult = ReturnType<typeof useGetAnimalPedigreeLazyQuery>;
export type GetAnimalPedigreeSuspenseQueryHookResult = ReturnType<typeof useGetAnimalPedigreeSuspenseQuery>;
export type GetAnimalPedigreeQueryResult = ApolloReactCommon.QueryResult<GetAnimalPedigreeQuery, GetAnimalPedigreeQueryVariables>;
export const GetAnimalExtrasDocument = gql`
    query GetAnimalExtras($animalId: Int!, $extraTypes: [String!]) {
  animalExtras(animalId: $animalId, extraTypes: $extraTypes) {
    societyId
    animalId
    extraType
    societyCode
    notes
    updatedAt
  }
}
    `;

/**
 * __useGetAnimalExtrasQuery__
 *
 * To run a query within a React component, call `useGetAnimalExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalExtrasQuery({
 *   variables: {
 *      animalId: // value for 'animalId'
 *      extraTypes: // value for 'extraTypes'
 *   },
 * });
 */
export function useGetAnimalExtrasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables> & ({ variables: GetAnimalExtrasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>(GetAnimalExtrasDocument, options);
      }
export function useGetAnimalExtrasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>(GetAnimalExtrasDocument, options);
        }
// @ts-ignore
export function useGetAnimalExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>;
export function useGetAnimalExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalExtrasQuery | undefined, GetAnimalExtrasQueryVariables>;
export function useGetAnimalExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>(GetAnimalExtrasDocument, options);
        }
export type GetAnimalExtrasQueryHookResult = ReturnType<typeof useGetAnimalExtrasQuery>;
export type GetAnimalExtrasLazyQueryHookResult = ReturnType<typeof useGetAnimalExtrasLazyQuery>;
export type GetAnimalExtrasSuspenseQueryHookResult = ReturnType<typeof useGetAnimalExtrasSuspenseQuery>;
export type GetAnimalExtrasQueryResult = ApolloReactCommon.QueryResult<GetAnimalExtrasQuery, GetAnimalExtrasQueryVariables>;
export const GetLotAnimalEbvsDocument = gql`
    query GetLotAnimalEbvs($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(
    documentsIsImagesOnly: true
    animalDocumentsIsImagesOnly: true
    requestInput: $requestInput
  ) {
    items {
      saleId
      sale {
        saleId
        saleName
        saleType
        saleDate
        publishTillDate
      }
      lotNo
      lotNotes
      lotAnimalName
      societyLotField1
      societyLotField2
      societyLotField3
      societyLotField4
      societyLotField5
      societyLotField6
      societyLotField7
      societyLotField8
      societyLotField9
      societyLotField10
      vendorsId
      vendorsName
      askingPrice
      askingPriceDesc
      salePrice
      salePriceDesc
      categoryCode
      agent
      lotCount
      semenFlag
      lotAnimalId
      societyId
      societyCode
      documents {
        documentGuid
        url
        isPrimary
        isDeleted
        fileName
        documentId
      }
      animalDocuments {
        documentGuid
        fileName
        url
        isPrimary
        isDeleted
        documentId
      }
      breederId
      breederIdent
      breederName
      breederDetailsAvailFlag
      calvingYear
      currentOwnerId
      currentOwnerIdent
      currentOwnerName
      currentOwnerDetailsAvailFlag
      damId
      damIdent
      damName
      dateOfBirth
      registrationStatus
      sex
      sireId
      sireIdent
      sireName
      animalId
      animalIdent
      animalName
      animalStatus
      animalTattoo
      traitLeader
      traitsObserved
      societyAnimalField1
      societyAnimalField2
      societyAnimalField3
      societyAnimalField4
      societyAnimalField5
      societyAnimalField6
      societyAnimalField7
      societyAnimalField8
      societyAnimalField9
      societyAnimalField10
      societyAnimalField11
      societyAnimalField12
      societyAnimalField13
      societyAnimalField14
      societyAnimalField15
      societyAnimalField16
      societyAnimalField17
      societyAnimalField18
      societyAnimalField19
      societyAnimalField20
      societyAnimalField21
      societyAnimalField22
      societyAnimalField23
      societyAnimalField24
      societyAnimalField25
      societyAnimalField26
      societyAnimalField27
      societyAnimalField28
      societyAnimalField29
      societyAnimalField30
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
      ebv1Percentile
      ebv2Percentile
      ebv3Percentile
      ebv4Percentile
      ebv5Percentile
      ebv6Percentile
      ebv7Percentile
      ebv8Percentile
      ebv9Percentile
      ebv10Percentile
      ebv11Percentile
      ebv12Percentile
      ebv13Percentile
      ebv14Percentile
      ebv15Percentile
      ebv16Percentile
      ebv17Percentile
      ebv18Percentile
      ebv19Percentile
      ebv20Percentile
      ebv21Percentile
      ebv22Percentile
      ebv23Percentile
      ebv24Percentile
      ebv25Percentile
      ebv26Percentile
      sireAnimalId
      sireAnimalIdent
      sireAnimalName
      sireEBV1
      sireEBV1Accuracy
      sireEBV2
      sireEBV2Accuracy
      sireEBV3
      sireEBV3Accuracy
      sireEBV4
      sireEBV4Accuracy
      sireEBV5
      sireEBV5Accuracy
      sireEBV6
      sireEBV6Accuracy
      sireEBV7
      sireEBV7Accuracy
      sireEBV8
      sireEBV8Accuracy
      sireEBV9
      sireEBV9Accuracy
      sireEBV10
      sireEBV10Accuracy
      sireEBV11
      sireEBV11Accuracy
      sireEBV12
      sireEBV12Accuracy
      sireEBV13
      sireEBV13Accuracy
      sireEBV14
      sireEBV14Accuracy
      sireEBV15
      sireEBV15Accuracy
      sireEBV16
      sireEBV16Accuracy
      sireEBV17
      sireEBV17Accuracy
      sireEBV18
      sireEBV18Accuracy
      sireEBV19
      sireEBV19Accuracy
      sireEBV20
      sireEBV20Accuracy
      sireEBV21
      sireEBV21Accuracy
      sireEBV22
      sireEBV22Accuracy
      sireEBV23
      sireEBV23Accuracy
      sireEBV24
      sireEBV24Accuracy
      sireEBV25
      sireEBV25Accuracy
      sireEBV26
      sireEBV26Accuracy
      damAnimalId
      damAnimalIdent
      damAnimalName
      damEBV1
      damEBV1Accuracy
      damEBV2
      damEBV2Accuracy
      damEBV3
      damEBV3Accuracy
      damEBV4
      damEBV4Accuracy
      damEBV5
      damEBV5Accuracy
      damEBV6
      damEBV6Accuracy
      damEBV7
      damEBV7Accuracy
      damEBV8
      damEBV8Accuracy
      damEBV9
      damEBV9Accuracy
      damEBV10
      damEBV10Accuracy
      damEBV11
      damEBV11Accuracy
      damEBV12
      damEBV12Accuracy
      damEBV13
      damEBV13Accuracy
      damEBV14
      damEBV14Accuracy
      damEBV15
      damEBV15Accuracy
      damEBV16
      damEBV16Accuracy
      damEBV17
      damEBV17Accuracy
      damEBV18
      damEBV18Accuracy
      damEBV19
      damEBV19Accuracy
      damEBV20
      damEBV20Accuracy
      damEBV21
      damEBV21Accuracy
      damEBV22
      damEBV22Accuracy
      damEBV23
      damEBV23Accuracy
      damEBV24
      damEBV24Accuracy
      damEBV25
      damEBV25Accuracy
      damEBV26
      damEBV26Accuracy
    }
    totalCount
  }
}
    `;

/**
 * __useGetLotAnimalEbvsQuery__
 *
 * To run a query within a React component, call `useGetLotAnimalEbvsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotAnimalEbvsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotAnimalEbvsQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetLotAnimalEbvsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables> & ({ variables: GetLotAnimalEbvsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>(GetLotAnimalEbvsDocument, options);
      }
export function useGetLotAnimalEbvsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>(GetLotAnimalEbvsDocument, options);
        }
// @ts-ignore
export function useGetLotAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>;
export function useGetLotAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLotAnimalEbvsQuery | undefined, GetLotAnimalEbvsQueryVariables>;
export function useGetLotAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>(GetLotAnimalEbvsDocument, options);
        }
export type GetLotAnimalEbvsQueryHookResult = ReturnType<typeof useGetLotAnimalEbvsQuery>;
export type GetLotAnimalEbvsLazyQueryHookResult = ReturnType<typeof useGetLotAnimalEbvsLazyQuery>;
export type GetLotAnimalEbvsSuspenseQueryHookResult = ReturnType<typeof useGetLotAnimalEbvsSuspenseQuery>;
export type GetLotAnimalEbvsQueryResult = ApolloReactCommon.QueryResult<GetLotAnimalEbvsQuery, GetLotAnimalEbvsQueryVariables>;
export const GetAnimalMediaLotDocumentsDocument = gql`
    query GetAnimalMediaLotDocuments($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(requestInput: $requestInput) {
    items {
      saleId
      lotNo
      lotAnimalId
      animalId
      sale {
        saleId
        saleName
        saleDate
      }
      documents {
        documentGuid
        documentId
        fileName
        url
        isPrimary
        isDeleted
        sequenceNumber
      }
      animalDocuments {
        documentGuid
        documentId
        fileName
        url
        isPrimary
        isDeleted
        sequenceNumber
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetAnimalMediaLotDocumentsQuery__
 *
 * To run a query within a React component, call `useGetAnimalMediaLotDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalMediaLotDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalMediaLotDocumentsQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetAnimalMediaLotDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables> & ({ variables: GetAnimalMediaLotDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>(GetAnimalMediaLotDocumentsDocument, options);
      }
export function useGetAnimalMediaLotDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>(GetAnimalMediaLotDocumentsDocument, options);
        }
// @ts-ignore
export function useGetAnimalMediaLotDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>;
export function useGetAnimalMediaLotDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalMediaLotDocumentsQuery | undefined, GetAnimalMediaLotDocumentsQueryVariables>;
export function useGetAnimalMediaLotDocumentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>(GetAnimalMediaLotDocumentsDocument, options);
        }
export type GetAnimalMediaLotDocumentsQueryHookResult = ReturnType<typeof useGetAnimalMediaLotDocumentsQuery>;
export type GetAnimalMediaLotDocumentsLazyQueryHookResult = ReturnType<typeof useGetAnimalMediaLotDocumentsLazyQuery>;
export type GetAnimalMediaLotDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetAnimalMediaLotDocumentsSuspenseQuery>;
export type GetAnimalMediaLotDocumentsQueryResult = ApolloReactCommon.QueryResult<GetAnimalMediaLotDocumentsQuery, GetAnimalMediaLotDocumentsQueryVariables>;
export const GetSalesDocument = gql`
    query GetSales($requestInput: SaleFilteredRequestInput!) {
  sales(requestInput: $requestInput) {
    items {
      lotCount
      saleDate
      saleId
      saleName
      saleNotes
      saleLocation
      saleDate
      saleType
      agent1 {
        agentId
        agentName
        agentUrl
        agentLogoFileName
        imageUrl
      }
      agent2 {
        agentId
        agentName
        agentUrl
        agentLogoFileName
        imageUrl
      }
      saleDateDescription
      extraInfoUrl1
      societySaleField1
    }
    totalCount
  }
}
    `;

/**
 * __useGetSalesQuery__
 *
 * To run a query within a React component, call `useGetSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetSalesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSalesQuery, GetSalesQueryVariables> & ({ variables: GetSalesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
      }
export function useGetSalesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
        }
// @ts-ignore
export function useGetSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSalesQuery, GetSalesQueryVariables>;
export function useGetSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSalesQuery | undefined, GetSalesQueryVariables>;
export function useGetSalesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSalesQuery, GetSalesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSalesQuery, GetSalesQueryVariables>(GetSalesDocument, options);
        }
export type GetSalesQueryHookResult = ReturnType<typeof useGetSalesQuery>;
export type GetSalesLazyQueryHookResult = ReturnType<typeof useGetSalesLazyQuery>;
export type GetSalesSuspenseQueryHookResult = ReturnType<typeof useGetSalesSuspenseQuery>;
export type GetSalesQueryResult = ApolloReactCommon.QueryResult<GetSalesQuery, GetSalesQueryVariables>;
export const GetMembersDocument = gql`
    query GetMembers($requestInput: MemberFilteredRequestInput!) {
  members(requestInput: $requestInput) {
    firstItemNumber
    hasNextPage
    hasPreviousPage
    lastItemNumber
    pageNumber
    pageSize
    totalCount
    totalPages
    items {
      address1
      address2
      address3
      breedplanFlag
      detailsAvailFlag
      email
      herdSize
      herdSizeDesc
      homepage
      itemKey
      mapDetails
      memberAuth
      memberId
      memberIdent
      memberNotes
      memberType
      memberName
      memberStatus
      phoneDetails
      postcode
      prefix
      renewalDate
      renewalFee
      societyCode
      societyId
      societyMemberField1
      societyMemberField10
      societyMemberField11
      societyMemberField12
      societyMemberField13
      societyMemberField14
      societyMemberField15
      societyMemberField2
      societyMemberField3
      societyMemberField4
      societyMemberField5
      societyMemberField6
      societyMemberField7
      societyMemberField8
      societyMemberField9
      sortname
      documents {
        fileName
        url
      }
    }
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables> & ({ variables: GetMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
// @ts-ignore
export function useGetMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMembersQuery, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMembersQuery | undefined, GetMembersQueryVariables>;
export function useGetMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersSuspenseQueryHookResult = ReturnType<typeof useGetMembersSuspenseQuery>;
export type GetMembersQueryResult = ApolloReactCommon.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetSocietyEbvLogoDocument = gql`
    query GetSocietyEbvLogo($societyId: String!) {
  societies(
    requestInput: {filterOptions: {field: SOCIETY_ID, operator: EQUALS, value: $societyId}, pagination: {currentPage: 1, pageSize: 10}}
  ) {
    items {
      settings(pageNumber: 1, pageSize: 150, societySettingTypes: SOCIETY_EBV_LOGO) {
        url
        settingUrl
        toolTip
      }
    }
  }
}
    `;

/**
 * __useGetSocietyEbvLogoQuery__
 *
 * To run a query within a React component, call `useGetSocietyEbvLogoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocietyEbvLogoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocietyEbvLogoQuery({
 *   variables: {
 *      societyId: // value for 'societyId'
 *   },
 * });
 */
export function useGetSocietyEbvLogoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables> & ({ variables: GetSocietyEbvLogoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>(GetSocietyEbvLogoDocument, options);
      }
export function useGetSocietyEbvLogoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>(GetSocietyEbvLogoDocument, options);
        }
// @ts-ignore
export function useGetSocietyEbvLogoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>;
export function useGetSocietyEbvLogoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSocietyEbvLogoQuery | undefined, GetSocietyEbvLogoQueryVariables>;
export function useGetSocietyEbvLogoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>(GetSocietyEbvLogoDocument, options);
        }
export type GetSocietyEbvLogoQueryHookResult = ReturnType<typeof useGetSocietyEbvLogoQuery>;
export type GetSocietyEbvLogoLazyQueryHookResult = ReturnType<typeof useGetSocietyEbvLogoLazyQuery>;
export type GetSocietyEbvLogoSuspenseQueryHookResult = ReturnType<typeof useGetSocietyEbvLogoSuspenseQuery>;
export type GetSocietyEbvLogoQueryResult = ApolloReactCommon.QueryResult<GetSocietyEbvLogoQuery, GetSocietyEbvLogoQueryVariables>;
export const CalculateMatingPredictionDocument = gql`
    query CalculateMatingPrediction($requestInput: MatingPredictorRequestInput!) {
  calculateMatingPrediction(requestInput: $requestInput) {
    calculatedAt
    selectionCriteria {
      sireIdents
      damIdents
      damCalvingYears
      displayBy
    }
    sires {
      animalId
      animalIdent
      animalName
      sex
      dateOfBirth
      sireId
      sireIdent
      sireName
      damId
      damIdent
      damName
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
    }
    dams {
      animalId
      animalIdent
      animalName
      sex
      dateOfBirth
      sireId
      sireIdent
      sireName
      damId
      damIdent
      damName
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
    }
    results {
      sireId
      damId
      projectedEbvs {
        ebvNumber
        value
        accuracy
        accuracyValue
        percentile
      }
      inbreeding {
        coefficient
        coefficientPercent
        minimumGenerations
        averageRelatedness
      }
    }
    breedAverages {
      ebvNumber
      value
      label
    }
    warnings
  }
}
    `;

/**
 * __useCalculateMatingPredictionQuery__
 *
 * To run a query within a React component, call `useCalculateMatingPredictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateMatingPredictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateMatingPredictionQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useCalculateMatingPredictionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables> & ({ variables: CalculateMatingPredictionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>(CalculateMatingPredictionDocument, options);
      }
export function useCalculateMatingPredictionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>(CalculateMatingPredictionDocument, options);
        }
// @ts-ignore
export function useCalculateMatingPredictionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>;
export function useCalculateMatingPredictionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CalculateMatingPredictionQuery | undefined, CalculateMatingPredictionQueryVariables>;
export function useCalculateMatingPredictionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>(CalculateMatingPredictionDocument, options);
        }
export type CalculateMatingPredictionQueryHookResult = ReturnType<typeof useCalculateMatingPredictionQuery>;
export type CalculateMatingPredictionLazyQueryHookResult = ReturnType<typeof useCalculateMatingPredictionLazyQuery>;
export type CalculateMatingPredictionSuspenseQueryHookResult = ReturnType<typeof useCalculateMatingPredictionSuspenseQuery>;
export type CalculateMatingPredictionQueryResult = ApolloReactCommon.QueryResult<CalculateMatingPredictionQuery, CalculateMatingPredictionQueryVariables>;
export const GetAnimalEbvCountDocument = gql`
    query GetAnimalEbvCount($requestInput: AnimalEbvFilteredRequestInput!) {
  animalEbvs(requestInput: $requestInput) {
    totalCount
  }
}
    `;

/**
 * __useGetAnimalEbvCountQuery__
 *
 * To run a query within a React component, call `useGetAnimalEbvCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnimalEbvCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnimalEbvCountQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetAnimalEbvCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables> & ({ variables: GetAnimalEbvCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>(GetAnimalEbvCountDocument, options);
      }
export function useGetAnimalEbvCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>(GetAnimalEbvCountDocument, options);
        }
// @ts-ignore
export function useGetAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>;
export function useGetAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAnimalEbvCountQuery | undefined, GetAnimalEbvCountQueryVariables>;
export function useGetAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>(GetAnimalEbvCountDocument, options);
        }
export type GetAnimalEbvCountQueryHookResult = ReturnType<typeof useGetAnimalEbvCountQuery>;
export type GetAnimalEbvCountLazyQueryHookResult = ReturnType<typeof useGetAnimalEbvCountLazyQuery>;
export type GetAnimalEbvCountSuspenseQueryHookResult = ReturnType<typeof useGetAnimalEbvCountSuspenseQuery>;
export type GetAnimalEbvCountQueryResult = ApolloReactCommon.QueryResult<GetAnimalEbvCountQuery, GetAnimalEbvCountQueryVariables>;
export const GetLotAnimalEbvCountDocument = gql`
    query GetLotAnimalEbvCount($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(requestInput: $requestInput) {
    totalCount
  }
}
    `;

/**
 * __useGetLotAnimalEbvCountQuery__
 *
 * To run a query within a React component, call `useGetLotAnimalEbvCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLotAnimalEbvCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLotAnimalEbvCountQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetLotAnimalEbvCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables> & ({ variables: GetLotAnimalEbvCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>(GetLotAnimalEbvCountDocument, options);
      }
export function useGetLotAnimalEbvCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>(GetLotAnimalEbvCountDocument, options);
        }
// @ts-ignore
export function useGetLotAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>;
export function useGetLotAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetLotAnimalEbvCountQuery | undefined, GetLotAnimalEbvCountQueryVariables>;
export function useGetLotAnimalEbvCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>(GetLotAnimalEbvCountDocument, options);
        }
export type GetLotAnimalEbvCountQueryHookResult = ReturnType<typeof useGetLotAnimalEbvCountQuery>;
export type GetLotAnimalEbvCountLazyQueryHookResult = ReturnType<typeof useGetLotAnimalEbvCountLazyQuery>;
export type GetLotAnimalEbvCountSuspenseQueryHookResult = ReturnType<typeof useGetLotAnimalEbvCountSuspenseQuery>;
export type GetLotAnimalEbvCountQueryResult = ApolloReactCommon.QueryResult<GetLotAnimalEbvCountQuery, GetLotAnimalEbvCountQueryVariables>;
export const GetMembersCountDocument = gql`
    query GetMembersCount($requestInput: MemberFilteredRequestInput!) {
  members(requestInput: $requestInput) {
    totalCount
  }
}
    `;

/**
 * __useGetMembersCountQuery__
 *
 * To run a query within a React component, call `useGetMembersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersCountQuery({
 *   variables: {
 *      requestInput: // value for 'requestInput'
 *   },
 * });
 */
export function useGetMembersCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMembersCountQuery, GetMembersCountQueryVariables> & ({ variables: GetMembersCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMembersCountQuery, GetMembersCountQueryVariables>(GetMembersCountDocument, options);
      }
export function useGetMembersCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMembersCountQuery, GetMembersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMembersCountQuery, GetMembersCountQueryVariables>(GetMembersCountDocument, options);
        }
// @ts-ignore
export function useGetMembersCountSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMembersCountQuery, GetMembersCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMembersCountQuery, GetMembersCountQueryVariables>;
export function useGetMembersCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembersCountQuery, GetMembersCountQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMembersCountQuery | undefined, GetMembersCountQueryVariables>;
export function useGetMembersCountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembersCountQuery, GetMembersCountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMembersCountQuery, GetMembersCountQueryVariables>(GetMembersCountDocument, options);
        }
export type GetMembersCountQueryHookResult = ReturnType<typeof useGetMembersCountQuery>;
export type GetMembersCountLazyQueryHookResult = ReturnType<typeof useGetMembersCountLazyQuery>;
export type GetMembersCountSuspenseQueryHookResult = ReturnType<typeof useGetMembersCountSuspenseQuery>;
export type GetMembersCountQueryResult = ApolloReactCommon.QueryResult<GetMembersCountQuery, GetMembersCountQueryVariables>;
export const QuickSearchAnimalEbvsDocument = gql`
    query QuickSearchAnimalEbvs($searchTerm: String!, $top: Int!, $sex: String) {
  quickSearchAnimalEbvs(searchTerm: $searchTerm, top: $top, sex: $sex) {
    animalId
    animalIdent
    animalName
    sex
    isEbvData
  }
}
    `;

/**
 * __useQuickSearchAnimalEbvsQuery__
 *
 * To run a query within a React component, call `useQuickSearchAnimalEbvsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchAnimalEbvsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchAnimalEbvsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      top: // value for 'top'
 *      sex: // value for 'sex'
 *   },
 * });
 */
export function useQuickSearchAnimalEbvsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables> & ({ variables: QuickSearchAnimalEbvsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>(QuickSearchAnimalEbvsDocument, options);
      }
export function useQuickSearchAnimalEbvsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>(QuickSearchAnimalEbvsDocument, options);
        }
// @ts-ignore
export function useQuickSearchAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>;
export function useQuickSearchAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickSearchAnimalEbvsQuery | undefined, QuickSearchAnimalEbvsQueryVariables>;
export function useQuickSearchAnimalEbvsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>(QuickSearchAnimalEbvsDocument, options);
        }
export type QuickSearchAnimalEbvsQueryHookResult = ReturnType<typeof useQuickSearchAnimalEbvsQuery>;
export type QuickSearchAnimalEbvsLazyQueryHookResult = ReturnType<typeof useQuickSearchAnimalEbvsLazyQuery>;
export type QuickSearchAnimalEbvsSuspenseQueryHookResult = ReturnType<typeof useQuickSearchAnimalEbvsSuspenseQuery>;
export type QuickSearchAnimalEbvsQueryResult = ApolloReactCommon.QueryResult<QuickSearchAnimalEbvsQuery, QuickSearchAnimalEbvsQueryVariables>;
export const QuickSearchMembersDocument = gql`
    query QuickSearchMembers($searchTerm: String!, $societyId: Int!, $top: Int!) {
  quickSearchMembers(searchTerm: $searchTerm, societyId: $societyId, top: $top) {
    memberId
    memberIdent
    memberName
  }
}
    `;

/**
 * __useQuickSearchMembersQuery__
 *
 * To run a query within a React component, call `useQuickSearchMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickSearchMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickSearchMembersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      societyId: // value for 'societyId'
 *      top: // value for 'top'
 *   },
 * });
 */
export function useQuickSearchMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<QuickSearchMembersQuery, QuickSearchMembersQueryVariables> & ({ variables: QuickSearchMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>(QuickSearchMembersDocument, options);
      }
export function useQuickSearchMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>(QuickSearchMembersDocument, options);
        }
// @ts-ignore
export function useQuickSearchMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>;
export function useQuickSearchMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<QuickSearchMembersQuery | undefined, QuickSearchMembersQueryVariables>;
export function useQuickSearchMembersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>(QuickSearchMembersDocument, options);
        }
export type QuickSearchMembersQueryHookResult = ReturnType<typeof useQuickSearchMembersQuery>;
export type QuickSearchMembersLazyQueryHookResult = ReturnType<typeof useQuickSearchMembersLazyQuery>;
export type QuickSearchMembersSuspenseQueryHookResult = ReturnType<typeof useQuickSearchMembersSuspenseQuery>;
export type QuickSearchMembersQueryResult = ApolloReactCommon.QueryResult<QuickSearchMembersQuery, QuickSearchMembersQueryVariables>;

export const GetSocieties = gql`
    query GetSocieties($currentPage: Int!, $pageSize: Int!, $searchTerm: String) {
  societies(
    requestInput: {pagination: {currentPage: $currentPage, pageSize: $pageSize}, sortOptions: {direction: ASCENDING, field: NAME}, searchTerm: $searchTerm}
  ) {
    items {
      societyId
      societyCode
      name
      breedLogicSocietyId
      isEbvEnabled
      isPrivate
    }
  }
}
    `;
export const GetSocietyByCode = gql`
    query GetSocietyByCode($societyCode: String!) {
  societies(
    requestInput: {pagination: {currentPage: 1, pageSize: 1}, filterOptions: {field: SOCIETY_CODE, operator: EQUALS, value: $societyCode}}
  ) {
    items {
      societyId
      societyCode
      name
      breedLogicSocietyId
      isEbvEnabled
      isPrivate
      currency
      country
    }
  }
}
    `;
export const GetSocietyAccessByCode = gql`
    query GetSocietyAccessByCode($societyCode: String!) {
  societyAccessByCode(societyCode: $societyCode) {
    exists
    isPrivate
    canAccess
    societyId
    societyCode
    name
  }
}
    `;
export const GetSocietySettings = gql`
    query GetSocietySettings {
  societySettings(
    pageNumber: 1
    pageSize: 150
    societySettingTypes: [ANIMAL_TAB, MEMBERS_TAB, EBV_TAB, SALES_TAB, MATING_TAB, SEMEN_CATALOG_TAB, DOWNLOADS_TAB, ONLINE_REGISTRATIONS_TAB, SOCIETY_LOGO, EBV_FIELDS, EBV_AVERAGE, EBV_DESCRIPTION, EBV_DESCRIPTION_URL, EBV_DISPLAY_OPTIONS, EBV_PERCENTAGES, EBV_PERCENTAGES_BR, DISPLAY_OPTIONS, ANIMAL_LIST_FIELDS, ANIMAL_DETAIL_FIELDS, LOT_DETAIL_FIELDS, ANIMAL_SEARCH_FIELDS, ANIMAL_SEARCH_FIELDS_EXCLUDE, ANIMAL_QUICK_SEARCH_DEFAULT_OPERATOR, MEMBER_LIST_FIELDS, MEMBER_DETAIL_FIELDS, MEMBER_SEARCH_FIELDS]
  ) {
    societyId
    value
    url
    settingUrl
    tooltip: toolTip
    societySettingType
    onlineRegistrationProvider
    ilrOnlineRegion
  }
}
    `;
export const GetAnimalEbvs = gql`
    query GetAnimalEbvs($requestInput: AnimalEbvFilteredRequestInput!) {
  animalEbvs(requestInput: $requestInput) {
    items {
      animalId
      animalIdent
      animalName
      animalStatus
      animalTattoo
      documents {
        documentGuid
        url
        isPrimary
        isDeleted
        fileName
        documentId
      }
      breederId
      breederName
      breederDetailsAvailFlag
      calvingYear
      saleCount
      hasProof
      currentOwnerId
      currentOwnerName
      currentOwnerDetailsAvailFlag
      damId
      damIdent
      damName
      dateOfBirth
      registrationStatus
      sex
      sireId
      sireIdent
      sireName
      societyId
      societyCode
      traitLeader
      traitsObserved
      numberOfHerds
      progenyCount
      scanProgenyCount
      carcaseProgenyCount
      daughtersCount
      ebvDescription
      societyAnimalField1
      societyAnimalField2
      societyAnimalField3
      societyAnimalField4
      societyAnimalField5
      societyAnimalField6
      societyAnimalField7
      societyAnimalField8
      societyAnimalField9
      societyAnimalField10
      societyAnimalField11
      societyAnimalField12
      societyAnimalField13
      societyAnimalField14
      societyAnimalField15
      societyAnimalField16
      societyAnimalField17
      societyAnimalField18
      societyAnimalField19
      societyAnimalField20
      societyAnimalField21
      societyAnimalField22
      societyAnimalField23
      societyAnimalField24
      societyAnimalField25
      societyAnimalField26
      societyAnimalField27
      societyAnimalField28
      societyAnimalField29
      societyAnimalField30
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
      ebv1Percentile
      ebv2Percentile
      ebv3Percentile
      ebv4Percentile
      ebv5Percentile
      ebv6Percentile
      ebv7Percentile
      ebv8Percentile
      ebv9Percentile
      ebv10Percentile
      ebv11Percentile
      ebv12Percentile
      ebv13Percentile
      ebv14Percentile
      ebv15Percentile
      ebv16Percentile
      ebv17Percentile
      ebv18Percentile
      ebv19Percentile
      ebv20Percentile
      ebv21Percentile
      ebv22Percentile
      ebv23Percentile
      ebv24Percentile
      ebv25Percentile
      ebv26Percentile
    }
    totalCount
  }
}
    `;
export const GetAnimalPedigree = gql`
    query GetAnimalPedigree($animalId: Int!, $maxGen: Int!) {
  pedigree(animalId: $animalId, maxGen: $maxGen) {
    maxGen
    root {
      animalId
      ident
      name
      sex
      dob
      ownerName
      ownerIdent
      status
      tattoo
    }
    nodes {
      animalId
      ident
      name
      sex
      dob
      ownerName
      ownerIdent
      status
      tattoo
      gen
      line
      parentId
      parentSide
      sireId
      damId
      path
    }
  }
}
    `;
export const GetAnimalExtras = gql`
    query GetAnimalExtras($animalId: Int!, $extraTypes: [String!]) {
  animalExtras(animalId: $animalId, extraTypes: $extraTypes) {
    societyId
    animalId
    extraType
    societyCode
    notes
    updatedAt
  }
}
    `;
export const GetLotAnimalEbvs = gql`
    query GetLotAnimalEbvs($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(
    documentsIsImagesOnly: true
    animalDocumentsIsImagesOnly: true
    requestInput: $requestInput
  ) {
    items {
      saleId
      sale {
        saleId
        saleName
        saleType
        saleDate
        publishTillDate
      }
      lotNo
      lotNotes
      lotAnimalName
      societyLotField1
      societyLotField2
      societyLotField3
      societyLotField4
      societyLotField5
      societyLotField6
      societyLotField7
      societyLotField8
      societyLotField9
      societyLotField10
      vendorsId
      vendorsName
      askingPrice
      askingPriceDesc
      salePrice
      salePriceDesc
      categoryCode
      agent
      lotCount
      semenFlag
      lotAnimalId
      societyId
      societyCode
      documents {
        documentGuid
        url
        isPrimary
        isDeleted
        fileName
        documentId
      }
      animalDocuments {
        documentGuid
        fileName
        url
        isPrimary
        isDeleted
        documentId
      }
      breederId
      breederIdent
      breederName
      breederDetailsAvailFlag
      calvingYear
      currentOwnerId
      currentOwnerIdent
      currentOwnerName
      currentOwnerDetailsAvailFlag
      damId
      damIdent
      damName
      dateOfBirth
      registrationStatus
      sex
      sireId
      sireIdent
      sireName
      animalId
      animalIdent
      animalName
      animalStatus
      animalTattoo
      traitLeader
      traitsObserved
      societyAnimalField1
      societyAnimalField2
      societyAnimalField3
      societyAnimalField4
      societyAnimalField5
      societyAnimalField6
      societyAnimalField7
      societyAnimalField8
      societyAnimalField9
      societyAnimalField10
      societyAnimalField11
      societyAnimalField12
      societyAnimalField13
      societyAnimalField14
      societyAnimalField15
      societyAnimalField16
      societyAnimalField17
      societyAnimalField18
      societyAnimalField19
      societyAnimalField20
      societyAnimalField21
      societyAnimalField22
      societyAnimalField23
      societyAnimalField24
      societyAnimalField25
      societyAnimalField26
      societyAnimalField27
      societyAnimalField28
      societyAnimalField29
      societyAnimalField30
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
      ebv1Percentile
      ebv2Percentile
      ebv3Percentile
      ebv4Percentile
      ebv5Percentile
      ebv6Percentile
      ebv7Percentile
      ebv8Percentile
      ebv9Percentile
      ebv10Percentile
      ebv11Percentile
      ebv12Percentile
      ebv13Percentile
      ebv14Percentile
      ebv15Percentile
      ebv16Percentile
      ebv17Percentile
      ebv18Percentile
      ebv19Percentile
      ebv20Percentile
      ebv21Percentile
      ebv22Percentile
      ebv23Percentile
      ebv24Percentile
      ebv25Percentile
      ebv26Percentile
      sireAnimalId
      sireAnimalIdent
      sireAnimalName
      sireEBV1
      sireEBV1Accuracy
      sireEBV2
      sireEBV2Accuracy
      sireEBV3
      sireEBV3Accuracy
      sireEBV4
      sireEBV4Accuracy
      sireEBV5
      sireEBV5Accuracy
      sireEBV6
      sireEBV6Accuracy
      sireEBV7
      sireEBV7Accuracy
      sireEBV8
      sireEBV8Accuracy
      sireEBV9
      sireEBV9Accuracy
      sireEBV10
      sireEBV10Accuracy
      sireEBV11
      sireEBV11Accuracy
      sireEBV12
      sireEBV12Accuracy
      sireEBV13
      sireEBV13Accuracy
      sireEBV14
      sireEBV14Accuracy
      sireEBV15
      sireEBV15Accuracy
      sireEBV16
      sireEBV16Accuracy
      sireEBV17
      sireEBV17Accuracy
      sireEBV18
      sireEBV18Accuracy
      sireEBV19
      sireEBV19Accuracy
      sireEBV20
      sireEBV20Accuracy
      sireEBV21
      sireEBV21Accuracy
      sireEBV22
      sireEBV22Accuracy
      sireEBV23
      sireEBV23Accuracy
      sireEBV24
      sireEBV24Accuracy
      sireEBV25
      sireEBV25Accuracy
      sireEBV26
      sireEBV26Accuracy
      damAnimalId
      damAnimalIdent
      damAnimalName
      damEBV1
      damEBV1Accuracy
      damEBV2
      damEBV2Accuracy
      damEBV3
      damEBV3Accuracy
      damEBV4
      damEBV4Accuracy
      damEBV5
      damEBV5Accuracy
      damEBV6
      damEBV6Accuracy
      damEBV7
      damEBV7Accuracy
      damEBV8
      damEBV8Accuracy
      damEBV9
      damEBV9Accuracy
      damEBV10
      damEBV10Accuracy
      damEBV11
      damEBV11Accuracy
      damEBV12
      damEBV12Accuracy
      damEBV13
      damEBV13Accuracy
      damEBV14
      damEBV14Accuracy
      damEBV15
      damEBV15Accuracy
      damEBV16
      damEBV16Accuracy
      damEBV17
      damEBV17Accuracy
      damEBV18
      damEBV18Accuracy
      damEBV19
      damEBV19Accuracy
      damEBV20
      damEBV20Accuracy
      damEBV21
      damEBV21Accuracy
      damEBV22
      damEBV22Accuracy
      damEBV23
      damEBV23Accuracy
      damEBV24
      damEBV24Accuracy
      damEBV25
      damEBV25Accuracy
      damEBV26
      damEBV26Accuracy
    }
    totalCount
  }
}
    `;
export const GetAnimalMediaLotDocuments = gql`
    query GetAnimalMediaLotDocuments($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(requestInput: $requestInput) {
    items {
      saleId
      lotNo
      lotAnimalId
      animalId
      sale {
        saleId
        saleName
        saleDate
      }
      documents {
        documentGuid
        documentId
        fileName
        url
        isPrimary
        isDeleted
        sequenceNumber
      }
      animalDocuments {
        documentGuid
        documentId
        fileName
        url
        isPrimary
        isDeleted
        sequenceNumber
      }
    }
    totalCount
  }
}
    `;
export const GetSales = gql`
    query GetSales($requestInput: SaleFilteredRequestInput!) {
  sales(requestInput: $requestInput) {
    items {
      lotCount
      saleDate
      saleId
      saleName
      saleNotes
      saleLocation
      saleDate
      saleType
      agent1 {
        agentId
        agentName
        agentUrl
        agentLogoFileName
        imageUrl
      }
      agent2 {
        agentId
        agentName
        agentUrl
        agentLogoFileName
        imageUrl
      }
      saleDateDescription
      extraInfoUrl1
      societySaleField1
    }
    totalCount
  }
}
    `;
export const GetMembers = gql`
    query GetMembers($requestInput: MemberFilteredRequestInput!) {
  members(requestInput: $requestInput) {
    firstItemNumber
    hasNextPage
    hasPreviousPage
    lastItemNumber
    pageNumber
    pageSize
    totalCount
    totalPages
    items {
      address1
      address2
      address3
      breedplanFlag
      detailsAvailFlag
      email
      herdSize
      herdSizeDesc
      homepage
      itemKey
      mapDetails
      memberAuth
      memberId
      memberIdent
      memberNotes
      memberType
      memberName
      memberStatus
      phoneDetails
      postcode
      prefix
      renewalDate
      renewalFee
      societyCode
      societyId
      societyMemberField1
      societyMemberField10
      societyMemberField11
      societyMemberField12
      societyMemberField13
      societyMemberField14
      societyMemberField15
      societyMemberField2
      societyMemberField3
      societyMemberField4
      societyMemberField5
      societyMemberField6
      societyMemberField7
      societyMemberField8
      societyMemberField9
      sortname
      documents {
        fileName
        url
      }
    }
  }
}
    `;
export const GetSocietyEbvLogo = gql`
    query GetSocietyEbvLogo($societyId: String!) {
  societies(
    requestInput: {filterOptions: {field: SOCIETY_ID, operator: EQUALS, value: $societyId}, pagination: {currentPage: 1, pageSize: 10}}
  ) {
    items {
      settings(pageNumber: 1, pageSize: 150, societySettingTypes: SOCIETY_EBV_LOGO) {
        url
        settingUrl
        toolTip
      }
    }
  }
}
    `;
export const CalculateMatingPrediction = gql`
    query CalculateMatingPrediction($requestInput: MatingPredictorRequestInput!) {
  calculateMatingPrediction(requestInput: $requestInput) {
    calculatedAt
    selectionCriteria {
      sireIdents
      damIdents
      damCalvingYears
      displayBy
    }
    sires {
      animalId
      animalIdent
      animalName
      sex
      dateOfBirth
      sireId
      sireIdent
      sireName
      damId
      damIdent
      damName
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
    }
    dams {
      animalId
      animalIdent
      animalName
      sex
      dateOfBirth
      sireId
      sireIdent
      sireName
      damId
      damIdent
      damName
      ebv1
      ebv1Accuracy
      ebv2
      ebv2Accuracy
      ebv3
      ebv3Accuracy
      ebv4
      ebv4Accuracy
      ebv5
      ebv5Accuracy
      ebv6
      ebv6Accuracy
      ebv7
      ebv7Accuracy
      ebv8
      ebv8Accuracy
      ebv9
      ebv9Accuracy
      ebv10
      ebv10Accuracy
      ebv11
      ebv11Accuracy
      ebv12
      ebv12Accuracy
      ebv13
      ebv13Accuracy
      ebv14
      ebv14Accuracy
      ebv15
      ebv15Accuracy
      ebv16
      ebv16Accuracy
      ebv17
      ebv17Accuracy
      ebv18
      ebv18Accuracy
      ebv19
      ebv19Accuracy
      ebv20
      ebv20Accuracy
      ebv21
      ebv21Accuracy
      ebv22
      ebv22Accuracy
      ebv23
      ebv23Accuracy
      ebv24
      ebv24Accuracy
      ebv25
      ebv25Accuracy
      ebv26
      ebv26Accuracy
    }
    results {
      sireId
      damId
      projectedEbvs {
        ebvNumber
        value
        accuracy
        accuracyValue
        percentile
      }
      inbreeding {
        coefficient
        coefficientPercent
        minimumGenerations
        averageRelatedness
      }
    }
    breedAverages {
      ebvNumber
      value
      label
    }
    warnings
  }
}
    `;
export const GetAnimalEbvCount = gql`
    query GetAnimalEbvCount($requestInput: AnimalEbvFilteredRequestInput!) {
  animalEbvs(requestInput: $requestInput) {
    totalCount
  }
}
    `;
export const GetLotAnimalEbvCount = gql`
    query GetLotAnimalEbvCount($requestInput: LotAnimalEbvFilteredRequestInput!) {
  lotAnimalEbvs(requestInput: $requestInput) {
    totalCount
  }
}
    `;
export const GetMembersCount = gql`
    query GetMembersCount($requestInput: MemberFilteredRequestInput!) {
  members(requestInput: $requestInput) {
    totalCount
  }
}
    `;
export const QuickSearchAnimalEbvs = gql`
    query QuickSearchAnimalEbvs($searchTerm: String!, $top: Int!, $sex: String) {
  quickSearchAnimalEbvs(searchTerm: $searchTerm, top: $top, sex: $sex) {
    animalId
    animalIdent
    animalName
    sex
    isEbvData
  }
}
    `;
export const QuickSearchMembers = gql`
    query QuickSearchMembers($searchTerm: String!, $societyId: Int!, $top: Int!) {
  quickSearchMembers(searchTerm: $searchTerm, societyId: $societyId, top: $top) {
    memberId
    memberIdent
    memberName
  }
}
    `;